import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const REVIEWS = [{
  name: 'Jessica M.',
  location: 'Broken Arrow, OK',
  text: 'Our water went from harsh and cloudy to crystal clear. The install was fast, clean, and the team was genuinely honest about what we needed.'
}, {
  name: 'David R.',
  location: 'Jenks, OK',
  text: 'No more spots on the dishes and my skin feels so much better after showers. Best home upgrade we have made. Highly recommend Tulsa Water Pros.'
}, {
  name: 'Amanda K.',
  location: 'Owasso, OK',
  text: 'Family-owned and it shows. They tested our water, explained everything, and the lifetime warranty gave us total peace of mind.'
}];
export function Reviews() {
  return <section id="reviews" className="bg-white py-20 sm:py-24" data-id="element-164" data-mp="3slwk034fwwlk">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-165" data-mp="1ds6gb24yheb">
        <SectionHeading eyebrow="Testimonials" title="Trusted by 100+ Tulsa families" subtitle="Don't just take our word for it — hear from neighbors who upgraded their water." data-id="element-166" data-mp="1ek19jnwsb3j" />

        <div className="mt-14 grid gap-6 lg:grid-cols-3" data-id="element-167" data-mp="27qcqds9gqv07">
          {REVIEWS.map((r, i) => <motion.figure key={r.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="relative flex flex-col rounded-3xl border border-slate-200 bg-slate-50 p-7" data-id="element-168" data-mp="22qq8v6mlqsll" data-mpi={i}>
              <Quote className="h-8 w-8 text-brand-cyan/40" data-id="element-169" data-mp="2mf8w3io1rvxn" />
              <div className="mt-3 flex" data-id="element-170" data-mp="2hgxjj06db7bq">
                {Array.from({
              length: 5
            }).map((_, s) => <Star key={s} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-171" data-mp="1b2y61k0oudww" data-mpi={s} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-700" data-id="element-172" data-mp="1618ywfgl6ke3">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3" data-id="element-173" data-mp="1citv6x3qu8k0">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-blue font-bold text-white" data-id="element-174" data-mp="1cgzl6du0g0up">
                  {r.name.charAt(0)}
                </span>
                <div data-id="element-175" data-mp="12j31gxn0bxkz">
                  <p className="text-sm font-bold text-navy-900" data-id="element-176" data-mp="12mqy45nr103x">{r.name}</p>
                  <p className="text-xs text-slate-500" data-id="element-177" data-mp="os6lq7e6javc">{r.location}</p>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}